const labels = {
  All: { 'See the offering': '提供内容をご確認ください' },
  FacilityDetails: { 'Ref: Page title': '施設詳細', 'Ref: Review': 'レビュー' },
  FacilitiesList: { 'Ref: Page title': '施設・設備', 'Ref: See details': '詳細を見る' },
};
export default labels;
